
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProviderPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"admin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isInternalUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"core"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerPreferenceDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerPreference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"admin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"admin"}}},{"kind":"Argument","name":{"kind":"Name","value":"isInternalUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isInternalUser"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPermission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissionCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissionSubCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codeDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"corporateProviderLastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"corporateProviderMpin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"corporateProviderName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isThirdParty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registeredOrg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servicingProviderFirstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servicingProviderLastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servicingProviderMpin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"servicingProviderName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxIdNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tinType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tpsm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tpsmCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tpsmDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tpsmEffDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tpsmCancDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uhcProviderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1099}};
    doc.loc.source = {"body":"query GetProviderPreference(\n  $uuid: String\n  $admin: AdminInput\n  $isInternalUser: Boolean\n) {\n  core {\n    providerPreferenceDetails {\n      providerPreference(\n        uuid: $uuid\n        admin: $admin\n        isInternalUser: $isInternalUser\n      ) {\n        allPermission\n        permissions\n        permissionCode\n        permissionSubCode\n        organizations {\n          name\n          organizationId\n          userId\n        }\n        provider {\n          code\n          codeDesc\n          corporateProviderLastName\n          corporateProviderMpin\n          corporateProviderName\n          isThirdParty\n          organizationId\n          organizationName\n          registeredOrg\n          servicingProviderFirstName\n          servicingProviderLastName\n          servicingProviderMpin\n          servicingProviderName\n          taxIdNumber\n          tinType\n          tpsm {\n            tpsmCode\n            tpsmDescription\n            tpsmEffDate\n            tpsmCancDate\n          }\n          uhcProviderId\n          uniqueId\n          userId\n          uuid\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetProviderPreference"] = oneQuery(doc, "GetProviderPreference");
        
